/**
 * @Author: Zewei
 * @Date:   2018-02-01T10:34:25+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-27T16:56:22+08:00
 */
 import { EmployeeManagement } from '../constants/employee-management-constants.js';

 const initState = {
     actionStatus: false,
     fileLocation: null,
     fetching: false,
 }

 export default function employeeManagement (state = initState, action) {
   switch (action.type) {
       // 花名册
       case EmployeeManagement.ActionTypes.FETCHDATA:
           return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.FETCHALLSUCCESS:
           return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.FETCHEMPLOYEEGROUPDATA:
           return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.FETCHEMPLOYEEUSERDATA:
           return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.FETCHSUCCESS:
           return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.FETCHFAILURE:
           return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.UPDATESUCCESS:
           return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.UPDATEFAILURE:
           return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.CREATESUCCESS:
           return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.CREATEFAILURE:
           return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.FETCHEXPORTCOLUMNSUCCESS:
           return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.FETCHEXPORTCOLUMNFAILURE:
           return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.EXPORTEMPLOYEESSUCCESS:
           return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.EXPORTEMPLOYEESFAILURE:
           return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.EMPTY:
            return {...state, ...action.payload};
       // 合同管理
       case EmployeeManagement.ActionTypes.FETCHCONTRACTLISTSUCCESS:
       case EmployeeManagement.ActionTypes.FETCHCONTRACTDETAILSUCCESS:
       case EmployeeManagement.ActionTypes.INITCONTRACTALERTSUCCESS:
       case EmployeeManagement.ActionTypes.CHANGECONTRACTOVERALERT:
       case EmployeeManagement.ActionTypes.CHANGECONTRACTPROBATIONOVERALERT:
          return { ...state, ...action.payload };
       case EmployeeManagement.ActionTypes.TOGGLEEDITCONTRACT:
          let copyEditState = { ...state };
          copyEditState.contractDetail[action.payload.index].unedit = !state.contractDetail[action.payload.index].unedit;
          return copyEditState;
       case EmployeeManagement.ActionTypes.NEWCONTRACT:
          let copyNewState = { ...state };
          copyNewState.contractDetail.push(action.payload.newContract);
          return copyNewState;
       case EmployeeManagement.ActionTypes.DELETECONTRACT:
          let copyDeleteState = { ...state };
          copyDeleteState.contractDetail.splice(action.payload.index, 1);
          return copyDeleteState;
       case EmployeeManagement.ActionTypes.ADDCONTRACTSUCCESS:
          let copyAddState = { ...state };
          copyAddState.contractDetail[action.payload.index].unsave = false;
          copyAddState.contractDetail[action.payload.index].unedit = true;
          copyAddState.contractDetail[action.payload.index].id = action.payload.id;
          return copyAddState;
       case EmployeeManagement.ActionTypes.CHANGECONTRACT:
          let copyChangeState = { ...state };
          if ('contract_properties' === action.payload.column) {
            copyChangeState.contractDetail[action.payload.index].property_id = action.payload.id;
            copyChangeState.contractDetail[action.payload.index].property_name = action.payload.name;
            copyChangeState.contractDetail[action.payload.index].is_active = !state.contractDetail[action.payload.index].is_active;
          }else if ('contract_statuses' === action.payload.column) {
            copyChangeState.contractDetail[action.payload.index].status_id = action.payload.id;
            copyChangeState.contractDetail[action.payload.index].status_name = action.payload.name;
          }else if ('contract_types' === action.payload.column) {
            copyChangeState.contractDetail[action.payload.index].type_id = action.payload.id;
            copyChangeState.contractDetail[action.payload.index].type_name = action.payload.name;
          }else{
            copyChangeState.contractDetail[action.payload.index][action.payload.column] = action.payload.id;
          }
          return copyChangeState;
       case EmployeeManagement.ActionTypes.EDITCONTRACTSUCCESS:
          let copyUpdateState = { ...state };
          copyUpdateState.contractDetail[action.payload.index].unsave = false;
          return copyUpdateState;
       case EmployeeManagement.ActionTypes.RECOVERCONCTRACT:
          let copyRecoverState = { ...state };
          copyRecoverState.contractDetail[action.payload.index] = action.payload.contract;
          return copyRecoverState;
       // 证件管理
       case EmployeeManagement.ActionTypes.FETCHCERTIFICATELISTSUCCESS:
          return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.FETCHCERTIFICATEEMPLOYEELISTSUCCESS:
          return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.FETCHCERTIFICATELISTFAILURE:
          return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.CREATECERTIFICATESUCCESS:
          return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.CREATECERTIFICATEFAILURE:
          return {...state, ...action.payload};
       case EmployeeManagement.ActionTypes.UPDATECERTIFICATESUCCESS:
          let copyUpdateCerticafte = { ...state };
          copyUpdateCerticafte.certificateList[action.payload.index] = action.payload.value;
          return copyUpdateCerticafte;
       case EmployeeManagement.ActionTypes.UPDATECERTIFICATEFAILURE:
       case EmployeeManagement.ActionTypes.CHANGECERTIFICATEVALUE:
          return {...state, ...action.payload};



       // 通讯录 Created by zangkang
      case EmployeeManagement.ActionTypes.FETCHADDRESSDATA:
          return {...state, ...action.payload};
      case EmployeeManagement.ActionTypes.FEACHADDRESSSUCCESS:
          return {...state, ...action.payload};
      case EmployeeManagement.ActionTypes.FETCHADDRESSFAILURE:
          return {...state, ...action.payload};
      case EmployeeManagement.ActionTypes.EXPORTADDRESSLISTSUCCESS:
          return {...state, ...action.payload};
      case EmployeeManagement.ActionTypes.EXPORTADDRESSLISTFAILURE:
          return {...state, ...action.payload};


       // 生日名单
      case EmployeeManagement.ActionTypes.FETCHSTAFFBIRTHDAYLISTSUCCESS:
          return {...state, ...action.payload};
      case EmployeeManagement.ActionTypes.FETCHSTAFFBIRTHDAYLISTFAILURE:
          return {...state, ...action.payload};
      case EmployeeManagement.ActionTypes.EXPORTSTAFFBIRTHDAYLISTSUCCESS:
          return {...state, ...action.payload};
      case EmployeeManagement.ActionTypes.EXPORTSTAFFBIRTHDAYLISTFAILURE:
          return {...state, ...action.payload};
      case EmployeeManagement.ActionTypes.FETCHSTAFFBIRTHDAYDETAILSUCCESS:
          return {...state, ...action.payload};
      case EmployeeManagement.ActionTypes.FETCHSTAFFBIRTHDAYDETAILFAILURE:
          return {...state, ...action.payload};
      //机票、住房
      case EmployeeManagement.ActionTypes.FETCHAIRTICKETSUBSIDYLISTSUCCESS:
          return {...state, ...action.payload};
      case EmployeeManagement.ActionTypes.FETCHHOUSINGALLOWANCELISTSUCCESS:
          return {...state, ...action.payload};

       // 月度报表

          
       //合同管理中获取合同到期前接收提醒人员列表
       case EmployeeManagement.ActionTypes.FETCHCONTRACTRECEIVEEXPIREMEMBERSUSSESS:
          return {...state, ...action.payload};

       // 默认 输出
       default:
           return {...state};
   }
 }



// WEBPACK FOOTER //
// ./src/reducers/employee-management-reducer.js